import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { AGREGGATOR } from '../models/keywords';
var packageName = '__tube_lang__';
export var runtimeNames = {
  pipe: packageName + '.pipe',
  curry: packageName + '.curry',
  sideEffect: packageName + '.sideEffect',
  negate: packageName + '.negate',
  union: packageName + '.union',
  curriedPreffix: '__tube_curried_'
};
export var generator = function generator(_ref) {
  var curriedFns = _ref.curriedFns,
      pipeExpressions = _ref.pipeExpressions,
      pipeInvocations = _ref.pipeInvocations;
  return _generator({
    type: 'Program',
    children: [].concat(_toConsumableArray(curriedFns), _toConsumableArray(pipeExpressions), _toConsumableArray(pipeInvocations))
  });
};

var _generator = function _generator(node) {
  var _a, _b;

  var args = '';

  switch (node.type) {
    case 'Program':
      return '\n' + node.children.map(_generator).join('\n') + '\n';

    case 'CurryStatement':
      return "const ".concat(getNameOfFunctionCurried(node.value), " = ").concat(runtimeNames.curry, "(").concat(node.value, ");");

    case 'PipeStatement':
      var leftHandSide = "const ".concat(node.value);
      var rightHandSide = "".concat(runtimeNames.pipe, "(").concat(node.children.map(_generator).join(', '), ")");
      return leftHandSide + ' = ' + rightHandSide + ';';

    case 'PipeInvocation':
      var pipeIIPE = "".concat(runtimeNames.pipe, "(").concat(node.children.map(_generator).join(', '), ")");
      var argWithParenthesis = '()';
      return "".concat(pipeIIPE).concat(argWithParenthesis, ";");

    case 'Function':
      var fn = '';
      var disableAutoCurrying = node.disableAutoCurrying;
      args = ((_a = node.args) === null || _a === void 0 ? void 0 : _a.map(_generator).join(', ')) || '';
      var argsWithParenthesis = args ? "(".concat(args, ")") : '';
      var defer = node.defer ? function (f) {
        return "() => ".concat(f);
      } : function (f) {
        return f;
      };
      var wrap = node.wrap ? function (f) {
        return "y => ".concat(f, "(y)");
      } : function (f) {
        return f;
      };

      if (AGREGGATOR.test(node.value)) {
        return "z => ([".concat(args.split(', ').map(function (f) {
          return f + '(z)';
        }).join(', '), "])");
      }

      if (!args || disableAutoCurrying) {
        fn = "".concat(node.value).concat(argsWithParenthesis);
      } else {
        fn = "".concat(getNameOfFunctionCurried(node.value)).concat(argsWithParenthesis);
      }

      if (node.negated) {
        fn = "".concat(runtimeNames.negate, "(").concat(fn, ")");
      }

      if (node["else"]) {
        fn = "x => ".concat(fn, "(x) ? (").concat(_generator(node["if"]), ")(x) : (").concat(_generator(node["else"]), ")(x)");
      } else if (node["if"]) {
        fn = "x => ".concat(fn, "(x) ? (").concat(_generator(node["if"]), ")(x) : x");
      } else if (node.flipArguments) {
        fn = "x => ".concat(getNameOfFunctionCurried(node.value), "(x)").concat(argsWithParenthesis);
      }

      return wrap(defer(fn));

    case 'SwitchStatement':
      var cases = node.cases.map(_generator).join(' : ');
      var defaultClause = node["default"] ? "".concat(node["default"].value, "(x)") : 'x';
      var switchFn = cases ? "x => ".concat(cases, " : ").concat(defaultClause) : "x => ".concat(defaultClause);
      return switchFn;

    case 'SwitchCase':
      return "".concat(node.predicate, "(x) ? ").concat(node.value, "(x)");

    case 'UnionStatement':
      return "".concat(runtimeNames.union, "(").concat(node.children.map(_generator).join(', '), ")");

    case 'Number':
    case 'Variable':
      return node.value;

    case 'String':
      return "'" + node.value + "'";

    case 'SideEffect':
      return "".concat(runtimeNames.sideEffect, "(").concat(node.value, ")");

    case 'Method':
      args = ((_b = node.args) === null || _b === void 0 ? void 0 : _b.map(_generator).join(', ')) || '';
      return "x => x.".concat(node.value, "(").concat(args, ")");

    default:
      throw new SyntaxError(node.type + ' type not supported');
  }
};

var getNameOfFunctionCurried = function getNameOfFunctionCurried(fn) {
  return "".concat(runtimeNames.curriedPreffix).concat(fn);
};